import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { HrtApiService } from '../hrt-api/hrt-api.service';
import { MeasurementSeriesDTO, RelatedOpDataResponseDTO } from '@shared/models';
import { DateHelper } from '@shared/helpers';

@Injectable({ providedIn: 'root' })
export class RelatedOperatingDataApiService {
  url = 'machines/{machine}/relatedOperatingDatas';

  readonly api = inject(HrtApiService);

  fetchRelatedOperatingData({
    machine,
    dateHours,
    temperatureUnit,
    pressureUnit,
  }: {
    machine: number;
    dateHours?: number;
    temperatureUnit?: string;
    pressureUnit?: string;
  }): Observable<MeasurementSeriesDTO[]> {
    const url = this.url.replace('{machine}', machine.toString());
    const queryParams = {
      dateRange: DateHelper.hoursBack(dateHours),
      temperatureUnit: temperatureUnit ?? '',
      pressureUnit: pressureUnit ?? '',
    };
    return this.api.getForOrganization<MeasurementSeriesDTO[]>(url, { params: queryParams });
  }

  public getSignalDataAndAvailability(
    machineId: string,
    signalTypeIds?: number[],
    dateRange?: string
  ): Observable<RelatedOpDataResponseDTO[]> {
    const endpointPath = `machines/${machineId}/relatedOperatingDatas`;

    let params = new HttpParams();
    if (signalTypeIds && signalTypeIds.length > 0) {
      params = params.set('signalTypeIds', signalTypeIds.join(','));
    }
    if (dateRange) {
      params = params.set('dateRange', dateRange);
    }

    return this.api.getForOrganization<RelatedOpDataResponseDTO[]>(endpointPath, { params });
  }
}
